export default {

    data() {
        return {
            selected: false
        }
    },

    watch: {
        selected(val) {
            if(!val)
                this.$emit('selectedFalse')
        }
    },

    methods: {
        deselect() {
            this.selected = false
            this.$emit('deselected')
        },

        keydown(evt) {
            if(evt.key === 'Escape' || evt.key === 'Enter')
                this.deselect()
        }
    },

    mounted() {
        document.addEventListener('click', this.deselect)
        document.addEventListener('keydown', this.keydown)
    },

    destroyed() {
        document.removeEventListener('click', this.deselect)
        document.removeEventListener('keydown', this.keydown)
    },

}
